import React, {ReactNode} from "react";
import {Dialog as MuiDialog} from "@mui/material";
import {useModal} from "@ebay/nice-modal-react";
import {CloseDialogButton, Container, Text} from "../../../../ui";
import {InputUtils} from "../../../../helpers";
import {useIsMobile} from "../../../helpers";

interface DialogProps {
  title?: string;
  image?: ReactNode;
  onClose?: () => void;
  alignCenter?: boolean;
  background?: string;
  children?: ReactNode;
}

export const CustomDialog = ({
  title,
  image,
  onClose,
  alignCenter = false,
  background = undefined,
  children,
}: DialogProps) => {
  const modal = useModal();
  const isMobile = useIsMobile();
  return (
    <MuiDialog
      open={modal.visible}
      TransitionProps={{
        onExited: () => {
          onClose?.();
          modal.remove();
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          padding: isMobile ? "44px 24px 24px 24px" : "44px",
          gap: "24px",
          "&.MuiPaper-elevation": {
            margin: "12px",
          },
          ...(background && {background}),
        },
      }}
    >
      <CloseDialogButton onClose={modal.hide} color={!!background} />
      <Container sx={{gap: "24px", width: "300px", alignItems: alignCenter ? "center" : "start"}}>
        {image}
        {title && (
          <Text variant={"interDisplay600"} size={24}>
            {InputUtils.prettierSnakeCaseSentence(title)}
          </Text>
        )}
        {children}
      </Container>
    </MuiDialog>
  );
};
